
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruit-staff",
      function () {
        return require("private-next-pages/recruit-staff/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruit-staff"])
      });
    }
  